import { render, staticRenderFns } from "./not-access.vue?vue&type=template&id=24904d0c&"
import script from "./not-access.vue?vue&type=script&lang=js&"
export * from "./not-access.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports